<template>
  <div class="kabaddi-season">
    <loading-state :state="state"></loading-state>
    <div v-if="season">
      <h2>{{season.name}}</h2>
      <kabaddi-season-menu :showSeason="true" :seasonKey="season.key"></kabaddi-season-menu>
      <section>
        <dl class="dl-tableview">
          <dt>Short Name</dt>
          <dd>{{season.short_name}}</dd>
          <dt>Start Date</dt>
          <dd>{{season.startDate | relativeShortDateTime}}</dd>
          <dt>Matches</dt>
          <dd>{{season.match_keys_by_date.length}}</dd>
        </dl>
      </section>
      <section v-if="recentMatches.length">
        <h3>Recent Matches</h3>
        <div class="sub-content">
          <div class="item compact link" v-for="match in recentMatches" :key="match.key">
            <kabaddi-match-mini :match="match"></kabaddi-match-mini>
          </div>
        </div>
      </section>
      <section>
        <h3>Teams</h3>
        <div class="sub-content">
          <div class="item compact link" v-for="team in teams" :key="team.key">
            <div>
              <router-link
              class="clean"
              :to="{name:'kabaddiSeasonTeam', params:{key:season.key, teamkey:team.key}}">
              {{team.name}} ({{team.short_name}})</router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { KabaddiSeason } from '@/models/kabaddi/season'
import { DataState, AppState } from '@/state'

export default {
  data () {
    return {
      seasonKey: this.$route.params.key,
      season: null,
      recentMatches: [],
      state: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  computed: {
    teams () {
      const allTeams = Object.values(this.season.teams)
      allTeams.sort((x, y) => {
        return (x.name < y.name) ? -1 : 1
      })

      return allTeams
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.seasonKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`kabadd_season_${this.seasonKey}`)
      AppState.updateTitles(newTitle, newTitle)

      KabaddiSeason.fetch(this.seasonKey).then(raw => {
        this.season = raw.season
        this.recentMatches = raw.recentMatches

        const newTitle = this.season.name
        AppState.updateTitles(newTitle, newTitle)

        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.season = null
      this.recentMatches = []
    },
    refreshView () {

    }
  }
}
</script>
